
import { RealTimeDashboard } from "../components/Dashboard/RealTimeDashboard";
import { usePinAuth } from "../hooks/usePinAuth";

const Index = () => {
  const { pinUser, isAuthenticated: isPinAuthenticated, loading: pinLoading } = usePinAuth();

  console.log('🏠 Index - État d\'authentification PIN:');
  console.log('  - PIN Auth:', { isPinAuthenticated, pinUser, pinLoading });

  // Attendre que le hook ait fini de charger
  if (pinLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Chargement...</div>
      </div>
    );
  }

  // Si l'utilisateur est connecté par PIN, afficher le dashboard
  if (isPinAuthenticated) {
    console.log('✅ Utilisateur authentifié par PIN, affichage du dashboard');
    return <RealTimeDashboard />;
  }

  // Sinon, rediriger vers la page de connexion PIN
  console.log('❌ Utilisateur non authentifié, redirection vers login PIN');
  window.location.href = '/login';
  return null;
};

export default Index;
